import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { useTriggerTravelCacheWarmupForEventMutation, TravelEventCacheWarmUpRequestUxType } from '@graphql/generated';
import { addError } from '@shared/utils/logger';

/**
 * Custom hook to handle travel cache warmup after venue updates.
 * Extracts common logic used in both VenueInfo and EventVenueDialog Form components.
 */
export const useTravelCacheWarmupOnVenueUpdate = () => {
  const [triggerTravelCacheWarmup] = useTriggerTravelCacheWarmupForEventMutation();

  const triggerWarmup = useEventCallback((eventHandle: string) => {
    triggerTravelCacheWarmup({
      variables: {
        payload: {
          eventHandle: eventHandle,
          scenario: TravelEventCacheWarmUpRequestUxType.HOST_CHANGED_VENUE,
        },
      },
    }).catch(error => {
      addError(error, { context: 'TravelCacheWarmup', message: 'Failed to trigger travel cache warmup after venue update' });
    });
  });

  return {
    triggerWarmup,
  };
};
